<template>
    <div name="input-phone" class="input-phone">
        <div class="header" @click="goBack">← 이전 화면</div>
        <div class="wrapper">
            <div class="input-area">
                <div class="title">건강 측정 결과 안내를 위해<br><span style="font-weight: 700;">휴대전화 번호를 입력해주세요</span></div>
                <span class="title-description">입력하신 번호로 건강 측정 결과가 발송됩니다.<br>(카카오톡 알림톡)</span>
                <div class="phone-input" v-if="step === 0">
                    <div class="pad-header">
                        <span class="warning">번호를 정확하게 입력하신 후 [확인] 버튼을 눌러주세요</span>
                        <div class="input">{{ convertPhone(number) }}</div>
                    </div>

                    <div class="number-pad">
                        <div class="number-page-row">
                            <div class="key" style="border-right: 2px solid var(--xi-gray-2, #C1C5C9);"  @click="inputNumber('1')">
                                <span class="number">1</span>
                            </div>
                            <div class="key" style="border-right: 2px solid var(--xi-gray-2, #C1C5C9);"  @click="inputNumber('2')">
                                <span class="number">2</span>
                            </div>
                            <div class="key" @click="inputNumber('3')">
                                <span class="number">3</span>
                            </div>
                        </div>  
                        <div class="number-page-row" style="border-top: 2px solid var(--xi-gray-2, #C1C5C9);">
                            <div class="key" style="border-right: 2px solid var(--xi-gray-2, #C1C5C9);" @click="inputNumber('4')">
                                <span class="number">4</span>
                            </div>
                            <div class="key" style="border-right: 2px solid var(--xi-gray-2, #C1C5C9);" @click="inputNumber('5')">
                                <span class="number">5</span>
                            </div>
                            <div class="key" @click="inputNumber('6')">
                                <span class="number">6</span>
                            </div>
                        </div>  
                        <div class="number-page-row" style="border-top: 2px solid var(--xi-gray-2, #C1C5C9);">
                            <div class="key" style="border-right: 2px solid var(--xi-gray-2, #C1C5C9);" @click="inputNumber('7')">
                                <span class="number">7</span>
                            </div>
                            <div class="key" style="border-right: 2px solid var(--xi-gray-2, #C1C5C9);" @click="inputNumber('8')">
                                <span class="number">8</span>
                            </div>
                            <div class="key" @click="inputNumber('9')">
                                <span class="number">9</span>
                            </div>
                        </div>  
                        <div class="number-page-row" style="border-top: 2px solid var(--xi-gray-2, #C1C5C9);">
                            <div class="key" style="border-right: 2px solid var(--xi-gray-2, #C1C5C9);" @click="backspace">
                                <img style="width: 3.2vw;" src="../../assets/showcase/xi/backspace.png" />
                            </div>
                            <div class="key" style="border-right: 2px solid var(--xi-gray-2, #C1C5C9);" @click="inputNumber('0')">
                                <span class="number">0</span>
                            </div>
                            <div :class="number.length === 11 ? 'enter-active':'enter'" @click="enter">
                               <span>확인</span>
                            </div>
                        </div>  
                    </div>
                </div>
                <div class="input-check" v-else>
                    <div class="phone-number-box">
                        <span class="phone-number-info-text">입력하신 휴대전화 번호가 정확한지<br>다시 한 번 확인해주세요.</span>
                        <span class="phone-number-text">{{ convertPhone(number) }}</span>
                    </div>

                    <div class="button-list">
                        <div class="button-yes">네,맞아요</div>
                        <div class="button-no">아니요,<br>다시 입력할게요</div>
                    </div>
                </div>

                <span class="info-text">※ 입력하신 개인정보는 체험 진행을 위한 용도로만 사용되며,<br>체험 종료 후 7일간 보관 후 안전하게 삭제됩니다.</span>
            </div>
            
        </div>
    </div>
</template>

<script>
export default {
    name: 'inputPhone',
    data: function()
    {
        return {
            step: 0,
            number: '010'
        }
    },
    methods: {
        convertPhone: function(number)
        {
            if(number.length <= 3)
            {
                return `${number.substring(0, 3)}-`
            }
            else if(number.length > 3 && number.length <= 7)
            {
                return `${number.substring(0, 3)}-${number.substring(3, 7)}`
            }
            else if(number.length > 7 && number.length <= 11)
            {
                return `${number.substring(0, 3)}-${number.substring(3, 7)}-${number.substring(7, 11)}`
            }
        },
        inputNumber: function(number)
        {
            if(this.number.length < 11)
            {   
                this.number += number;
            }
        },
        backspace: function()
        {
            if(this.number.length > 3)
            {
                this.number = this.number.substring(0, this.number.length -1)
            }
        },
        enter: function()
        {
            if(this.number.length === 11)
            {
                this.step = 1;   
            }
        },
        goBack: function()
        {
            this.$emit('back')
        }
    }
}
</script>

<style scoped>
    .input-phone {
        width: 100%;
        height: 100vh;
        overflow: hidden;    
    }
    .wrapper {
        padding: 6.2vh 5vw;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
    }
    .header {
        height: 9vh;
        width: 100%;
        font-size: 2vh;
        color: var(--xi-dark-blue, #173C55);
        font-family: Pretendard;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        letter-spacing: -1.12px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-left: 5%;
        box-sizing: border-box;
    }
    .input-area {
        box-sizing: border-box;
        padding: 4.6vh 16vw;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        border-top: 2px solid var(--xi-gray-2, #C4CBD2);
        border-bottom: 2px solid var(--xi-gray-2, #C4CBD2);
    }
    .title {
        color: var(--xi-dark-gray, #131415);
        text-align: center;
        font-family: Pretendard;
        font-size: 3vh;
        font-style: normal;
        font-weight: 500;
        line-height: 131%;
        letter-spacing: -2.64px;
    }
    .title-description {
        font-size: 1.8vh;
        color: var(--xi-dark-gray, #131415);
        text-align: center;
        font-family: Pretendard;
        font-style: normal;
        font-weight: 500;
        line-height: 133.333%;
        letter-spacing: -1.44px;
        margin-top: 1.2vh;
    }
    .phone-input {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        padding: 1.5vh 0;
        margin-top: 3.8vh;
    }
    .input {
        width: 100%;
        height: 5vh;
        font-size: 5.2vw;
        color: var(--xi-dark-gray, #131415);
        text-align: center;
        font-family: Pretendard;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        letter-spacing: -2.4px;
        margin-top: 0.9vh;
    }
    .warning {
        color: var(--xi-blue, #8BB9D7);
        text-align: center;
        font-family: Pretendard;
        font-size: 2.2vw;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        letter-spacing: -1.08px;
    }
    .number-pad {
        width: 100%;
        border: 2px solid var(--xi-gray-2, #C1C5C9);
        background: var(--xi-gray-0, #FFF);
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
    }
    .number-page-row {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .key {
        width: 100%;
        aspect-ratio: 1.6/1;
        background: var(--xi-gray-0, #FFF);
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .enter {
        width: 100%;
        aspect-ratio: 1.6/1;
        background: var(--xi-gray-1, #F0F1F4);
        display: flex;
        justify-content: center;
        align-items: center;

        color: var(--xi-gray-2, #C1C5C9);
        text-align: center;
        font-family: Pretendard;
        font-size: 3.8vw;
        font-style: normal;
        font-weight: 500;
        line-height: 0; /* 0% */
    }
    .enter-active{
        width: 100%;
        aspect-ratio: 1.6/1;
        background: var(--xi-dark-blue, #173C55);
        display: flex;
        justify-content: center;
        align-items: center;
        color: var(--xi-gray-0, #FFF);
        text-align: center;
        font-family: Pretendard;
        font-size: 3.8vw;
        font-style: normal;
        font-weight: 500;
        line-height: 0; /* 0% */
    }
    .number {
        color: var(--xi-dark-gray, #131415);
        text-align: center;
        font-family: Pretendard;
        font-size: 4.4vw;
        font-style: normal;
        font-weight: 500;
        line-height: 0; /* 0% */
        letter-spacing: -1.28px;
    }
    .pad-header {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        border: 2px solid var(--xi-gray-2, #C1C5C9);
        border-bottom: 0;
        box-sizing: border-box;
        padding-top: 1.5vh;
    }
    .info-text {
        color: var(--xi-gray-3, #8F9499);
        text-align: center;
        font-family: Pretendard;
        font-size: 2.5vw;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        letter-spacing: -1.08px;
        margin-top: 4.6vh;

    }
    .input-check {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        margin-top: 3.8vh;
    }
    .phone-number-box {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 7.6vh 0;
        background: var(--xi-gray-1, #F0F1F4);
    }
    .phone-number-info-text {
        color: var(--xi-blue, #8BB9D7);
        text-align: center;
        font-family: Pretendard;
        font-size: 2.9vw;
        font-style: normal;
        font-weight: 500;
        line-height: 133.333%;
        letter-spacing: -1.44px;
    }
    .phone-number-text {
        color: var(--xi-dark-gray, #131415);
        text-align: center;
        font-family: Pretendard;
        font-size: 5.5vw;
        font-style: normal;
        font-weight: 700;
        line-height: normal;
        letter-spacing: -2.4px;
        margin-top: 0.9vh;
    }
    .button-list {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 2.7vw;
        margin-top: 1.5vh;
        padding: 0 2vw 6.2vh 2vw;
    }
    .button-yes {
        border-radius: 16px;
        background: var(--xi-dark-blue, #173C55);
        width: 100%;
        aspect-ratio: 2.16/1;
        color: var(--xi-gray-0, #FFF);
        text-align: center;
        font-family: Pretendard;
        font-size: 3vw;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .button-no {
        border-radius: 16px;
        background: var(--xi-gray-1, #F0F1F4);
        width: 100%;
        aspect-ratio: 2.16/1;
        color: var(--xi-dark-gray, #131415);
        text-align: center;
        font-family: Pretendard;
        font-size: 3vw;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>


// WEBPACK FOOTER //
// src/components/showcase/InputPhone.vue